import React, { PropTypes } from 'react';
import AddItemCard from '../../../generic-components/add-item-card/add-item-card';
import EditButton from '../../../generic-components/edit-button';
import MouseOverEditDiv from '../../../../tc-ui/mouse-over-edit-div';
import HelperLink from '../../product/helper-link';

const GroupPolicy = ({
  groupInfo,
  editGroup,
  addGroup,
  supplierEditable,
  deletePolicy,
  hideLabel,
  classes = {},
  inMaster,
}) => {
  if (!(groupInfo && Object.keys(groupInfo).length)) {
    return (
      <div>
        <div id="groupPolicy">
          <HelperLink value="group" justLabel={inMaster}>Group Policy</HelperLink>
        </div>
        <AddItemCard onClick={addGroup} text="Add group policy" editable={supplierEditable} />
      </div>
    );
  }
  return (
    <div id="groupPolicy">
      <HelperLink
        value="group"
        openEditDialog={editGroup}
        labelText={!hideLabel && 'Group Policy'}
        justLabel={inMaster}
      />
      <MouseOverEditDiv
        className={classes.main}
        editable={supplierEditable}
        extendPadding
        actionButtons={
          <EditButton
            onEdit={editGroup}
            deleteButton={Boolean(deletePolicy)}
            onDelete={deletePolicy}
          />
        }
      >
        <div style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
          {classes['conditions-textblock'] || groupInfo.conditions}
        </div>
      </MouseOverEditDiv>
    </div>
  );
};

GroupPolicy.propTypes = {
  groupInfo: PropTypes.object,
  editGroup: PropTypes.func,
  addGroup: PropTypes.func,
  supplierEditable: PropTypes.bool,
  inMaster: PropTypes.bool,
};

export default GroupPolicy;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-policies/policies/group.jsx